<template>
  <div>
    <div id="animationRef" class="analy-loading"></div>
  </div>
</template>

<script>
import lottie from 'lottie-web'
import animationLoading from '@/assets/animation/loading.json'
export default {
  name: 'Analyzing-Loading',
  data() {
    return {
      loadingAnalyzingObj:null
    }
  },
  mounted() {
    this.initAnimation()
  },
  methods: {
    // 初始化的动画
    initAnimation() {
      this.$nextTick(() => {
        console.log('initAnimation dom', document.getElementById('animationRef'))
        this.loadingAnalyzingObj = lottie.loadAnimation({
          container: document.getElementById('animationRef'),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationLoading
        })
        console.log('initAnimation****', this.loadingAnalyzingObj)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.analy-loading {
  width: 64px;
  height: 64px;
}
</style>>